export default {"scrollableRow":"sraLN","noSidePadding":"Apy7-"};